import PropTypes from 'prop-types';
import { forwardRef } from 'react';
// material
import { IconButton } from '@mui/material';
import { Icon } from '@iconify/react';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import { ButtonAnimate } from '../animate';

// ----------------------------------------------------------------------
const MIconButton = forwardRef(({ children, icon, ...other }, ref) => (
  <ButtonAnimate>
    <IconButton ref={ref} {...other}>
      {children || (
      <Icon icon={icon || moreVerticalFill} width={20} height={20} />
      )}
    </IconButton>
  </ButtonAnimate>
));

MIconButton.propTypes = {
  children: PropTypes.node,
};

export default MIconButton;
